import Axios from 'axios';
import { getHeaders } from '../../utills';
import Apis from '../Apis';
import GeneralAction from '../Actions/GeneralAction';
import ChatActions from '../Actions/ChatActions';
import AlertAction from '../Actions/AlertActions';

class ChatMiddleware {


  static getChatIndex = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          // if (userData?.search || userData?.next_page_url == undefined) {
          //   if (userData?.search && userData?.next_page_url) {
          //   }
          //   else {
          //     dispatch(CategoriesActions.clearCleanerCategories())
          //   }
          // }
          
          if (userData?.search || userData?.next_page_url == undefined) {
            if (userData?.search && userData?.next_page_url) {
            }
            else {
              dispatch(ChatActions.clearChatIndex())
            }
            
          }
          let formdata = new FormData();
          if (userData?.search) {
            formdata.append('search', userData?.search);
          }
          const { data } = await Axios.post(
            Apis.chatIndex(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(ChatActions.getChatIndex(data?.data))
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          // alert('Network Error');
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getViewChatlist = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.next_page_url == undefined) {
            dispatch(ChatActions.clearMessageList())
          }
          const { data } = await Axios.get(
            Apis.viewChatlist(userData?.next_page_url, userData?.id),
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(ChatActions.getMessageList(data?.data))
            resolve(data?.data)
            dispatch(GeneralAction.HideLoading());

          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          // alert('Network Error');
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static chatlistCheck = (id) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('id', id);
          const { data } = await Axios.post(
            Apis.chatlistCheck,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data)
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          // alert('Network Error');
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static SendMessage = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('user_id', userData?.userId);
          formdata.append('type', userData?.type);
          if (userData?.type == 'text') {
            formdata.append('message', userData?.typeMessage)
          } else {
            formdata.append('message', userData?.typeMessage)
            formdata.append('media', userData?.media)
          }
          // { userData?.type == 'text' ? formdata.append('message', userData?.typeMessage) : formdata.append('media', userData?.media); }
          const { data } = await Axios.post(
            Apis.sendMessage,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data?.success)
            console.log('=====>', data?.message)
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            dispatch(GeneralAction.HideLoading());
            // Alert.alert('Note', data?.message)
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          dispatch(GeneralAction.HideLoading());
          // alert('Network Error');
          console.log(error);
        }
      });
    };
  };


  // static sendAttachment = (userData) => {
  //   return async dispatch => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let headers = await getHeaders()
  //         const response = await RNFetchBlob
  //           .config({ timeout: 60 * 60 })
  //           .fetch("POST", Apis.sendMessage,
  //             headers.documentheaders,
  //             [
  //               {
  //                 name: "user_id",
  //                 data: userData?.userId.toString(),
  //               },
  //               {
  //                 name: "type",
  //                 data: userData?.type,
  //               },
  //               {
  //                 name: "media",
  //                 filename: userData?.media?.name,
  //                 data: RNFetchBlob.wrap(userData?.media?.uri),
  //                 type: userData?.media?.type,

  //               },
  //             ])
  //         if (JSON.parse(response?.data)?.success) {
  //           resolve(JSON.parse(response?.data)?.success)
  //           console.log("====>", JSON.parse(response?.data)?.message)
  //         }
  //         else {
  //           reject(JSON.parse(response?.data)?.success)
  //           dispatch(AlertAction.ShowAlert({ type: "error", message: JSON.parse(response.data)?.message }))
  //           // Alert.alert("Note", JSON.parse(response.data)?.message)
  //           console.log("====>", JSON.parse(response?.data)?.message)
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
  //         // Alert.alert("Note","Network error!")
  //         console.log(error);
  //       }
  //     });
  //   };
  // };
}

export default ChatMiddleware;
